import {
  initialState,
  Actions,
  State,
  GET_POST,
  GET_POST_SUCCESS,
  GET_POST_ERROR,
  RESET_GET_POST,
  UPDATE_CURRENT_POST,
} from "../../types/post/get-post";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_POST:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_POST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_POST_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: false,
          error: action.payload,
          success: false,
        },
      };
    case UPDATE_CURRENT_POST:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case RESET_GET_POST:
      return initialState;
    default:
      return state;
  }
};

export default reducers;
